// src/App.js

import React,{useEffect,useState } from 'react';
import AppRoutes from './Routes';
import './App.css';

function CountdownModal({ targetDate, onClose }) {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        dias: Math.floor(difference / (1000 * 60 * 60 * 24)),
        horas: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutos: Math.floor((difference / 1000 / 60) % 60),
        segundos: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  return (
    <div className="modal-overlay-data">
      <div className="modal-content-data">
        <h2>Início da pré-venda do SF Bros V2 em:</h2>
        <div className="contador-data">
          <span>{timeLeft.dias ?? '0'}d </span>
          <span>{timeLeft.horas ?? '0'}h </span>
          <span>{timeLeft.minutos ?? '0'}m </span>
          <span>{timeLeft.segundos ?? '0'}s</span>
        </div>
        <button onClick={onClose} className="fechar-modal-data">Fechar</button>
      </div>
    </div>
  );
}

function App() {
  const [showModal, setShowModal] = useState(() => {
    const modalShown = sessionStorage.getItem('sfbrosModalShown');
    return !modalShown; // true apenas se ainda não foi mostrado
  });
  const handleCloseModal = () => {
  sessionStorage.setItem('sfbrosModalShown', 'true');
  setShowModal(false);
};
  useEffect(() => {
    //ReactGA.pageview(window.location.pathname + window.location.search);
    //console.log(window.location.pathname + window.location.search);
  }, []);
  return (
    <div className="App">
      <AppRoutes />
      
    </div>
  );
}
/*{showModal && (
  <CountdownModal 
    targetDate="2025-07-14T12:00:00" 
    onClose={handleCloseModal} 
  />
)}*/
export default App;
